import { CacheTable } from './cache-table';

export class CacheApi<T = any> extends CacheTable<T> {

  constructor() {
    super('api', 'performance');
  }
}
